import * as React from 'react';
import { AddBillinginfo } from './AddBillingInfo';
import { storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import { PlanSelection } from './components/PlansView';
import { AppStorePlan, isOrder, Order } from './Order';
import { Overlay } from '../components/Overlay';
import { trackEvent } from 'utils/Tracker';
import { WaitForStripe } from './WaitForStripe';
import { useUser } from 'hooks/useUser';
import { usePrevious } from 'hooks/usePrevious';
import { isPro } from 'utils';
import { WaitForAppStore } from './WaitForAppStore';
import { Modal } from 'components/Modal';
import { SignIn } from 'signin/SignIn';

const BuySection: React.FC<{}> = () => {
  const [orderOrStorePlan, setOrderOrStorePlan] = React.useState<
    Order | AppStorePlan | null
  >(null);
  const user = useUser();

  const plan = user?.plan;
  const planExpiration = user?.planExpiration;
  const previousPlan = usePrevious(plan);
  const previousPlanExpiration = usePrevious(planExpiration);

  const didChoosePlan = React.useCallback(
    (newOrderOrPlan: Order | AppStorePlan) => {
      trackEvent('Started Order', { plan: newOrderOrPlan.plan });
      setOrderOrStorePlan(newOrderOrPlan);
    },
    []
  );

  const didCancelOrder = React.useCallback(() => {
    trackEvent('Cancelled Order', { plan: orderOrStorePlan?.plan });
    storeDispatch(Actions.goBack());
  }, [orderOrStorePlan]);

  React.useEffect(() => {
    storeDispatch({ type: Actions.OPEN_PAGE });
    return () => {
      storeDispatch({ type: Actions.CLOSE_PAGE });
    };
  }, []);

  React.useEffect(() => {
    if (user === null || previousPlan === undefined) {
      return;
    }
    // console.log(
    //   'RENDER BUY --EFFECT',
    //   plan,
    //   planExpiration,
    //   previousPlan,
    //   previousPlanExpiration
    // );
    if (
      isPro(user) &&
      (plan !== previousPlan ||
        (planExpiration ?? 0) > (previousPlanExpiration ?? 0))
    ) {
      trackEvent('Completed Order', { plan });
      storeDispatch(Actions.goBack());
      if (user.segmentationSurvey === undefined) {
        setTimeout(() => {
          storeDispatch(Actions.showSegmentationSurvey());
        }, 100);
      }
    }
  }, [user, plan, planExpiration, previousPlan, previousPlanExpiration]);

  let node = <div />;
  if (orderOrStorePlan === null) {
    node = <PlanSelection onSelect={didChoosePlan} />;
  } else if (user === null) {
    node = (
      <Modal>
        <SignIn
          onClose={success => {
            if (!success) {
              didCancelOrder();
            }
          }}
        />
      </Modal>
    );
  } else {
    if (isOrder(orderOrStorePlan)) {
      if (!user.customerId) {
        node = <AddBillinginfo />;
      } else {
        node = (
          <WaitForStripe
            user={user}
            order={orderOrStorePlan}
            onCancel={didCancelOrder}
          />
        );
      }
    } else {
      node = (
        <WaitForAppStore
          user={user}
          storeProduct={orderOrStorePlan}
          onCancel={didCancelOrder}
        />
      );
    }
  }
  return <Overlay>{node}</Overlay>;
};

export default BuySection;



// WEBPACK FOOTER //
// ./src/buy/index.tsx